import * as actions from './actions'

const catalogCurpSexesModule = {
    namespaced: true,
    actions,
}

export default catalogCurpSexesModule
